import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Table } from '@/components/Table';
import { EmptyState } from '@/components/EmptyState';
import { ConfirmActionDialog } from '@components/ConfirmActionDialog';
import { clientAccessActionTypes } from '@store/ClientAccess/ClientAccess.actionTypes';

import { clientsTabConfig } from './ClientsTab.config';
import employeeListStyles from '../EmployeeList.module.scss';
import styles from './IntegrationImportTab.module.scss';

export const ClientsTab = ({ companyId, teamId, teamLabel }) => {
  const dispatch = useDispatch();
  const [revokeTarget, setRevokeTarget] = useState(null);

  const listState = useSelector((state) => state.clientAccess.list);
  const revokeState = useSelector((state) => state.clientAccess.revoke);

  useEffect(() => {
    if (companyId && teamId) {
      dispatch({
        type: clientAccessActionTypes.GET_TEAM_CLIENTS,
        payload: { companyId, teamId },
      });
    }
  }, [companyId, teamId, dispatch]);

  const confirmRevoke = () => {
    if (!revokeTarget) return;
    dispatch({
      type: clientAccessActionTypes.REVOKE_CLIENT_ACCESS,
      payload: {
        companyId,
        clientUid: revokeTarget.id,
        teamIds: [teamId],
      },
    });
    setRevokeTarget(null);
  };

  const columns = clientsTabConfig({
    teamLabel,
    onRevoke: setRevokeTarget,
    revoking: revokeState.pending,
  });

  if (!companyId || !teamId) {
    return (
      <div className={styles.emptyState}>
        Select a company and department to view clients.
      </div>
    );
  }

  if (listState.pending) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.spinner} />
        Loading clients…
      </div>
    );
  }

  return (
    <>
      <ConfirmActionDialog
        visible={Boolean(revokeTarget)}
        onHide={() => setRevokeTarget(null)}
        title="Revoke client access"
        message={`${revokeTarget?.name || 'This client'} will lose access to this department's dashboard.`}
        confirmLabel="Revoke access"
        loading={revokeState.pending}
        onConfirm={confirmRevoke}
      />
      {listState.data.length === 0 ? (
        <EmptyState
          illustration
          title="No Clients Found"
          description="No clients have been added to this department yet."
        />
      ) : (
        <Table
          className={employeeListStyles.employeeTable}
          data={listState.data}
          columns={columns}
        />
      )}
    </>
  );
};
ClientsTab.displayName = 'ClientsTab';
